import dayjs from 'dayjs';
import React from 'react';

interface TimelineProps {
  startDate: string;
  endDate: string;
  intervals: number;
  subdivisions?: number;
}

const TimelineDots = React.memo(
  ({ startDate, endDate, intervals, subdivisions = 4 }: TimelineProps) => {
    const totalMinutes = dayjs(endDate).diff(dayjs(startDate), 'minute');

    const step = totalMinutes / intervals;

    const minorCount = intervals * subdivisions;
    const minorStep = step / subdivisions;

    return (
      <>
        {/* Etiquetas cada `step` minutos */}
        {Array.from({ length: intervals + 1 }, (_, i) => (
          <div
            key={`label-${i}`}
            className="timeline-interval"
            style={{
              left: `${((i * step) / totalMinutes) * 100}%`,
            }}
          >
            {`${Math.round(i * step)}m`}
          </div>
        ))}

        {/* Puntos menores dentro de cada intervalo */}
        {Array.from({ length: minorCount }, (_, idx) => {
          const intervalIndex = Math.floor(idx / subdivisions);
          const subIndex = idx % subdivisions;
          const minutes = intervalIndex * step + subIndex * minorStep;

          return (
            <div
              key={`dot-${idx}`}
              className="timeline-dot"
              style={{
                left: `${(minutes / totalMinutes) * 100}%`,
              }}
            >
              &bull;
            </div>
          );
        })}
      </>
    );
  },
);

export default TimelineDots;
